import React, {useEffect, useState} from "react";
import DashboardLayout from "../../layouts/Dashboard";
import { useTranslation } from "react-i18next";
import { SearchPanel, TableCustom } from "../../components";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getReagents, addReagent, editReagent, deleteReagent, getReagentByKey } from "../../redux/actions/reagentActions";
import CreateReagent from "./Popups/CreateReagent";
import ReagentDetails from "./Popups/ReagentDetails";
import EditReagent from "./Popups/EditReagent";
import RemoveReagent from "./Popups/RemoveReagent";

function createData(id, name, description, price) {
    return {id, name, description, price};
}

let rows = [
    createData(1, "abc", "abc", 1.0),
];
const ReagentList = () => {
    const {t} = useTranslation();
    const rowName = [
        {text: t("reagentList.tableItem.id")},
        {text: t("reagentList.tableItem.name")},
        {text: t("reagentList.tableItem.description")},
        {text: t("reagentList.tableItem.price")},
        {text: t("reagentList.tableItem.actions")},
    ];
    const dispatch = useDispatch();

    const [query, setQuery] = useState({ "sort": { "id": { "operator": "asc" } } });

    const [id, setId] = useState(null);
    const [createOpen, setCreateOpen] = useState(false);
    const setCreateHandler = async () => {
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setCreateOpen(true);
        setId(null);
    }
    const createSubmit = async (_) => {
        await dispatch(addReagent(_, query));
    }
    const [detailsOpen, setDetailsOpen] = useState(false);
    const setDetailsHandler = async (id) => {
        await dispatch(getReagentByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setDetailsOpen(true);
        setId(id);
    }
    
    const [editOpen, setEditOpen] = useState(false);
    const setEditHandler = async (id) => {
        await dispatch(getReagentByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setEditOpen(true);
        setId(id);
    }
    const editSubmit = async (_) => {
        await dispatch(editReagent(_, query));
    }
    const [removeOpen, setRemoveOpen] = useState(false);
    const setRemoveHandler = async (id) => {
        await dispatch(getReagentByKey(id));
        setCreateOpen(false);
        setDetailsOpen(false);
        setEditOpen(false);
        setRemoveOpen(false);
        setRemoveOpen(true);
        setId(id);
    }
    const removeSubmit = async (_) => {
        await dispatch(deleteReagent(_.id, query));
    }

    const localData = false;
    const state = useSelector((state) => state.reagent);
    if (!localData && state.reagents)
    {
        rows = state.reagents;
    }
    useEffect(() => {
        if (!localData)
        {
            dispatch(getReagents(query));
        }
    }, [dispatch]);
    return (
        <DashboardLayout>
            <Box sx={{margin: '20px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <SearchPanel searchName="id" search={rows} label={t("reagentList.searchLabel")}/>
                <Button color="primary" variant="contained" onClick={() => setCreateHandler()}>
                    {t("reagentList.createText")}
                </Button>
            </Box>
            <TableCustom avatars={false} rowName={rowName} rows={rows.map(_ => {
                return {
                    id: _.id,
                    name: _.name,
                    description: _.description,
                    price: _.price,
                }
            })} actions={(_) => [<VisibilityIcon onClick={() => setDetailsHandler(_.id)}/>,<EditIcon onClick={() => setEditHandler(_.id)}/>,<DeleteForeverIcon onClick={() => setRemoveHandler(_.id)}/>]}/>
            <CreateReagent action={'create'} title={t("reagentList.createText")} open={createOpen} setOpen={setCreateOpen} onSubmit={createSubmit}/>
            <ReagentDetails action={'details'} title={t("reagentList.detailsText")} open={detailsOpen} setOpen={setDetailsOpen} />
            <EditReagent action={'edit'} title={t("reagentList.editText")} open={editOpen} setOpen={setEditOpen} onSubmit={editSubmit}/>
            <RemoveReagent action={'remove'} title={t("reagentList.removeText")} open={removeOpen} setOpen={setRemoveOpen} onSubmit={removeSubmit}/>
        </DashboardLayout>
    )
};

export default ReagentList;
